module.exports = __webpack_public_path__ + "img/gatewaybig.3f1e25e4.png";